import { render, staticRenderFns } from "./IrrigationUpkeepStartForm.vue?vue&type=template&id=5bf5a935&scoped=true&lang=html&"
import script from "./IrrigationUpkeepStartForm.vue?vue&type=script&lang=js&"
export * from "./IrrigationUpkeepStartForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf5a935",
  null
  
)

export default component.exports